import { faCheckSquare, faSquare } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { SellerEntity } from "@/mk2/apps/bazaar/schemas";
import { Interpolate } from "@/mk2/components/Interpolate";
import useEventCallback from "@/mk2/hooks/useEventCallback";
import { UserEntity } from "@/mk2/schemas";
import {
    BAZAAR_SHOW_MY_PHONE_NUMBER,
    BAZAAR_SHOW_MY_phone_number,
    MORE_BUYERS_WILL_CONTACT_YOU,
} from "@/mk/autogenerated/translation";

import styles from "./SellerShowPhone.mscss";

interface OwnProps {
    className?: string;
    seller: SellerEntity;
    sellerPhone?: string;
    requestUser: UserEntity;
    onSetShowSellerPhone?(value: boolean);
}

type Props = OwnProps;

export const SellerShowPhone: React.FunctionComponent<Props> = React.memo(
    ({ className, seller, requestUser, onSetShowSellerPhone, sellerPhone }) => {
        const showSellerPhone = seller.showSellerPhone;

        const onShowSellerPhoneChange = useEventCallback(
            (event: React.FormEvent<HTMLInputElement>) => {
                onSetShowSellerPhone(!showSellerPhone);
            },
            [onSetShowSellerPhone],
        );

        return (
            <div className={cx(styles.SellerShowPhone, className)}>
                <label className={styles.SellerShowPhone__label}>
                    <div className={styles.SellerShowPhone__label__icon}>
                        <FontAwesomeIcon icon={showSellerPhone ? faCheckSquare : faSquare} />
                    </div>
                    <input
                        checked={showSellerPhone}
                        className={styles.SellerShowPhone__label__input}
                        id="showSellerPhone"
                        type="checkbox"
                        onChange={onShowSellerPhoneChange}
                    />
                    {requestUser.phoneVerified ? (
                        <Interpolate
                            i18nKey={BAZAAR_SHOW_MY_phone_number}
                            phone_number={sellerPhone}
                        />
                    ) : (
                        <div>{BAZAAR_SHOW_MY_PHONE_NUMBER}</div>
                    )}
                </label>
                <p className={styles.SellerShowPhone__additionalText}>
                    {MORE_BUYERS_WILL_CONTACT_YOU}
                </p>
            </div>
        );
    },
);

SellerShowPhone.displayName = "SellerShowPhone";
